import { mainApi } from '../../../api/mainApi';
import { AccessState, AuthState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { NotificationResponse } from '../interfaces/notifications.interface';
import { addNotificationCounter } from '../reducers/accessReducer';

export const notificationTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Notifications'],
});
// Define a service using a base URL and expected endpoints
export const notificationApi = notificationTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Obtiene las notificaciones paginadas
     */
    getNotifications: builder.query<
      NotificationResponse,
      {
        page: number;
        perPage: number;
        search?: string;
        onlyPending?: boolean;
      }
    >({
      queryFn: async ({ page, perPage, search, onlyPending }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<NotificationResponse>(
            `/users/announcements/receivers`,
            {
              params: {
                user_profile_id,
                ...(onlyPending && { onlyPending }),
                page,
                size: perPage,
                search,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error) => [{ type: 'Notifications', id: 'LIST' }],
    }),

    /**
     * Obtiene las notificaciones paginadas
     */
    getNotificationsCount: builder.query<
      number,
      {
        onlyPending?: boolean;
      }
    >({
      queryFn: async ({ onlyPending }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<number>(`/users/announcements/pending`, {
            params: { user_profile_id, ...(onlyPending && { onlyPending }) },
          });

          return { data: typeof data === 'number' ? data : 0 };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error) => [{ type: 'Notifications', id: 'LIST' }],
    }),

    /**
     * Obtiene las notificaciones paginadas
     */
    readNotification: builder.mutation<
      any,
      {
        announcementId: number;
      }
    >({
      queryFn: async ({ announcementId }, { getState, dispatch }) => {
        try {
          const {
            access: { currentProfile },
            auth,
          } = getState() as { access: AccessState; auth: AuthState };

          const userId = auth.userInfo.id;
          const user_profile_id = currentProfile?.profileId;

          // es get en el back
          const { data } = await mainApi.put<any>(
            `/users/${userId}/announcements/${announcementId}/read?user_profile_id=${user_profile_id}`,
            {
              user_profile_id,
            }
          );

          dispatch(addNotificationCounter(-1));

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error) => [{ type: 'Notifications', id: 'LIST' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetNotificationsCountQuery,
  useLazyGetNotificationsCountQuery,
  // useReadNotificationMutation,
  useReadNotificationMutation,
} = notificationApi;
